import React from "react";
import { Award, Users, Star, Target, Eye, HeartHandshake } from "lucide-react";
import "../styles/Empresa.css";

const Empresa = () => {
    const valores = [
        {
            icon: <Target size={28} />,
            title: "Missão",
            description:
                "Transformar madeira de demolição em produtos de alto padrão, unindo sustentabilidade, design e exclusividade.",
        },
        {
            icon: <Eye size={28} />,
            title: "Visão",
            description:
                "Ser referência nacional em soluções premium de madeira, reconhecida pela inovação, responsabilidade e qualidade.",
        },
        {
            icon: <HeartHandshake size={28} />,
            title: "Valores",
            description:
                "Sustentabilidade, ética, compromisso com o cliente, respeito à história da madeira e busca constante pela excelência.",
        },
    ];

    return (
        <section id="empresa" className="empresa-section">
            {/* Hero interno */}
            <div className="page-hero">
                <div className="page-hero__overlay" />
                <div className="page-hero__content">
                    <h1 className="page-hero__title">Empresa</h1>
                    <div className="page-breadcrumbs">
                        <span className="page-breadcrumbs__link">Início</span>
                        <span className="page-breadcrumbs__sep">›</span>
                        <span className="page-breadcrumbs__current">Empresa</span>
                    </div>
                </div>
            </div>

            <div className="empresa-container">
                {/* História */}
                <div className="empresa-block">
                    <h2>Tradição e Inovação</h2>
                    <p>
                        Há mais de 15 anos, a <strong>ROS Dormentes</strong> se dedica a
                        transformar dormentes ferroviários e madeiras de demolição em peças
                        exclusivas. Cada produto carrega consigo não apenas design premium,
                        mas também a história e a força da madeira nobre.
                    </p>
                    <p>
                        Nosso compromisso é entregar soluções que unem rusticidade e
                        sofisticação, respeitando o meio ambiente e garantindo
                        durabilidade para cada projeto.
                    </p>
                </div>

                {/* Missão / Visão / Valores */}
                <div className="empresa-mvv">
                    {valores.map((v, i) => (
                        <div key={i} className="mvv-card">
                            <div className="icon">{v.icon}</div>
                            <h3>{v.title}</h3>
                            <p>{v.description}</p>
                        </div>
                    ))}
                </div>

                {/* Números / Métricas */}
                <div className="empresa-metrics">
                    <div>
                        <Award size={32} />
                        <h4>15+</h4>
                        <span>Anos de Experiência</span>
                    </div>
                    <div>
                        <Users size={32} />
                        <h4>500+</h4>
                        <span>Projetos Realizados</span>
                    </div>
                    <div>
                        <Star size={32} />
                        <h4>100%</h4>
                        <span>Clientes Satisfeitos</span>
                    </div>
                </div>

                {/* CTA */}
                <div className="empresa-cta">
                    <h2>Tem um projeto em mente?</h2>
                    <p>
                        Nossa equipe está pronta para desenvolver soluções exclusivas que
                        atendam às suas necessidades com sofisticação e qualidade.
                    </p>
                    <a href="#contato" className="btn-primary">
                        Solicitar Orçamento
                    </a>
                </div>
            </div>
        </section>
    );
};

export default Empresa;
